const webCrawlerUserAgentNames = [
    "googlebot", // Google Crawler
    "bingbot", // Bing Crawler
    "slurp", // Yahoo! Slurp
    "duckduckbot", // DuckDuckGo Bot
    "baiduspider", // Baidu Crawler
    "yandex", // Yandex Crawler
    "sogou", // Sogou Crawler
    "exabot", // Exalead Crawler
    "facebot", // Facebook Crawler
    "ia_archiver", // Internet Archive Crawler
];
export function userIsWebCrawler() {
    try {
        const userAgent = navigator.userAgent.toLowerCase();
        return webCrawlerUserAgentNames.some((name) => userAgent.includes(name));
    }
    catch {
        return false;
    }
}
